import { selectChangeMessageForThemes } from '@UI/aside/asideThemes/AsideThemesSelectors';
import { type ContentHref, ContentType } from '@generalTypes/apiTypes';
import type { EditAsideThemes } from '@nodeTypeConfig/configTypes';
import constants from '@store/constants/constants';

export const faqThemesComponent: EditAsideThemes = {
  component: 'faqType',
  property: 'themes',
  reactComponent: 'AsideThemes',
  label: 'Categorie FAQ-groep',
  options: {
    referenceFrameHref: `/content/${constants.faqCategoriesKey}` as ContentHref,
    types: [ContentType.THEME],
  },
  asideChangeMessageSelector: selectChangeMessageForThemes,
};
